import { LandingPageComponent } from './landing-page.component';
import { FormInlineErrorModule } from '../../shared/component/form-inline-error/form-inline-error.module';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedComponentsModule } from 'src/app/shared/modules/sharedComponentsModule';
import { LandingPageRoutingModule } from './landing-page-routing.module';
import { AllProductsComponent } from './components/all-products/all-products.component';
import { ArchitectureServiceComponent } from './components/architecture-service/architecture-service.component';
import { PlatformsComponent } from './components/platforms/platforms.component';
import { CloudEngineeringComponent } from './components/cloud-engineering/cloud-engineering.component';
import { DataComponent } from './components/data/data.component';
import { OneViewComponent } from './components/one-view/one-view.component';


  @NgModule({
      declarations: [
          LandingPageComponent,
          AllProductsComponent,
          ArchitectureServiceComponent,
          PlatformsComponent,
          CloudEngineeringComponent,
          DataComponent,
          OneViewComponent
      ],
      imports: [
          FormsModule,
          ReactiveFormsModule,
          CommonModule,
          FormInlineErrorModule,
          SharedComponentsModule,
          LandingPageRoutingModule
      ],
      exports: [LandingPageComponent],
      schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
  })
  export class LandingPageModule {}
